import { createEffect, createResource, For, Show, Suspense } from "solid-js"
import { StandardMeasurementDiv, STANDARD_SIZE_DROPDOWNS } from "../components/StandardMeasurementGroup"
import { useHeroForm } from "../contexts/HeroFormContext"
import { SizeGuide, SizeGuideV2 } from "../components/SizeGuide"
import { closeModalAndValidate } from "../js/formValidation"

const checkForThumbnailAvailability = (measurements) => {
  for (const measurement of measurements) {
    if (measurement.thumbnailSrc != undefined && measurement.thumbnailSrc?.trim().length > 0) {
      return true;
    }
  }
  return false;
}

export const getBlogPost = async (shopGraphQlUrl, accessToken, guideLinkUrl) => {

  let splitted_link = undefined;

  if (guideLinkUrl != undefined) {
    splitted_link = guideLinkUrl.split('/')
  }

  let blog_name = '';
  let article_name = '';

  if (splitted_link != undefined && splitted_link.length > 1) {
    blog_name = splitted_link[splitted_link.length - 2]
    article_name = splitted_link[splitted_link.length - 1]
  }

  if (blog_name != '' && article_name != '') {
    const reqBody = `{
      blogByHandle(handle: "${blog_name}") {
        articleByHandle(handle: "${article_name}") {
          title
          contentHtml
        }
      }
    }`

    const response = await fetch(shopGraphQlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": `${accessToken}`
      },
      body: reqBody
    })

    try {
      const res = await response.json();
      const { blogByHandle } = res.data;

      if (blogByHandle != null) {
        return blogByHandle?.articleByHandle?.contentHtml;
      } else {
        return '';
      }
    } catch (error) {
      console.log("response: ", response);
      console.log("error: ", error);
      return '';
    }

  } else {
    return '';
  }
}

export const StandardSizeForm = () => {

  const {
    sizeSettings: {
      standardSizeData,
      measurementOptions,
      handlers: {
        handleAnchorGradedChange,
        handleNonAnchorUngradedChange
      }
    },
    sizeSettings,
    fit: {
      fit
    },
    navBarData: {
      handlers: {
        handleNavBarVisiblity
      }
    }
  } = useHeroForm();





  const isStandardSizeValid = () => {
    const sizeData = standardSizeData().measurements;
    const anchorGraded = Object.values(sizeData.anchorGraded)[0];
    const nonAnchorUngraded = sizeData.nonAnchorUngraded;
    return Object.values(nonAnchorUngraded).map((obj) => obj.selected != "").every(Boolean) && anchorGraded.selected != "";

  }



  const anchorGradedMeasurements = () => Object.values(standardSizeData()['measurements']['anchorGraded']);
  const nonAnchorUngradedMeasurements = () => Object.values(standardSizeData()['measurements']['nonAnchorUngraded']);
  let isThereAnyThumbnail = false;
  isThereAnyThumbnail = checkForThumbnailAvailability(anchorGradedMeasurements())

  if (!isThereAnyThumbnail) {
    isThereAnyThumbnail = checkForThumbnailAvailability(nonAnchorUngradedMeasurements());
  }
  return (
    <div
      class="flex flex-col sm:pt-6 gap-2 mb-2 w-full"
    >
      <For each={anchorGradedMeasurements()}>
        {(measurement, index) => (
          <StandardMeasurementDiv
            type="anchorGraded"
            measurement={measurement}
            selectedFit={fit()['selected']}
            isThereAnyThumbnail={isThereAnyThumbnail}
            handleSelection={handleAnchorGradedChange}
            version={STANDARD_SIZE_DROPDOWNS.V1}
          />
        )}
      </For>
      <For each={nonAnchorUngradedMeasurements()}>
        {(measurement, index) => (
          <StandardMeasurementDiv
            type="nonAnchorUngraded"
            measurement={measurement}
            isThereAnyThumbnail={isThereAnyThumbnail}
            handleSelection={handleNonAnchorUngradedChange}
            version={STANDARD_SIZE_DROPDOWNS.V1}
          />
        )}
      </For>
      {standardSizeData().subheading}



      <Show when={standardSizeData().sizeGuide != undefined && Object.keys(standardSizeData().sizeGuide).length > 0}>
        <Show when={measurementOptions().options['standard-size'].subHeading}>
          <div class="w-full sm:w-4/5 mx-auto px-2 font-mono text-xs">{measurementOptions().options['standard-size'].subHeading}</div>
        </Show>

        <div class="px-2">
          <div class={`rounded-full w-full text-center p-1 grow my-2 ${isStandardSizeValid() ? 'bg-ink cursor-pointer text-canvas ' : 'bg-secondary-300 text-secondary-100'}`}
            onClick={() => { if (isStandardSizeValid()) closeModalAndValidate(handleNavBarVisiblity, sizeSettings) }}
          >Save & Continue</div>
        </div>

        <SizeGuide data={standardSizeData().sizeGuide} ></SizeGuide>
      </Show>


    </div>
  )

}

export const StandardSizeFormV2 = (props) => {

  const {
    sizeSettings: {
      standardSizeData,
      handlers: {
        handleAnchorGradedChange,
        handleNonAnchorUngradedChange
      }
    },
    fit: {
      fit
    }
  } = props.context();

  const anchorGradedMeasurements = () => Object.values(standardSizeData()['measurements']['anchorGraded']);
  const nonAnchorUngradedMeasurements = () => Object.values(standardSizeData()['measurements']['nonAnchorUngraded']);
  let isThereAnyThumbnail = false;
  isThereAnyThumbnail = checkForThumbnailAvailability(anchorGradedMeasurements())

  if (!isThereAnyThumbnail) {
    isThereAnyThumbnail = checkForThumbnailAvailability(nonAnchorUngradedMeasurements());
  }
  return (
    <div
      class={`flex flex-col gap-2 w-full pb-2`}
      classList={{
        "pt-2 px-2": !props.isOnlyStandardSize
      }}
    >
      <For each={anchorGradedMeasurements()}>
        {(measurement, index) => (
          <StandardMeasurementDiv
            type="anchorGraded"
            measurement={measurement}
            selectedFit={fit()['selected']}
            isThereAnyThumbnail={isThereAnyThumbnail}
            handleSelection={handleAnchorGradedChange}
            version={STANDARD_SIZE_DROPDOWNS.V2}
          />
        )}
      </For>
      <For each={nonAnchorUngradedMeasurements()}>
        {(measurement, index) => (
          <StandardMeasurementDiv
            type="nonAnchorUngraded"
            measurement={measurement}
            isThereAnyThumbnail={isThereAnyThumbnail}
            handleSelection={handleNonAnchorUngradedChange}
            version={STANDARD_SIZE_DROPDOWNS.V2}
          />
        )}
      </For>
      {standardSizeData().subheading}




    </div>
  )

}